import { useSelector } from 'react-redux'

import MultiBarCard from '../../../components/ReusableComponents/Charts/Inslghts/MultiBar/index'
import PieCard from '../../../components/ReusableComponents/Charts/Inslghts/Pie/index'
import { repeatGuestSorter } from '../../../utils/insightsHelpers'
import { ReactComponent as DecreaseIcon } from './decrease.svg'
import { ReactComponent as IncreaseIcon } from './increase.svg'
import styles from './RepeatGuests.module.scss'

const RepeatGuestsPie = ({ oneTimeGuests }) => {
  if (!oneTimeGuests) {
    return null
  }

  if (oneTimeGuests.length < 3) {
    return null
  }

  const thisYearsTotalGuestNumber = oneTimeGuests[oneTimeGuests.length - 2].totalGuests

  const thisYearsRepeatGuestsNumber =
    oneTimeGuests[oneTimeGuests.length - 2].totalRepeatingClients
  const lastYearsRepeatGuestsNumber =
    oneTimeGuests[oneTimeGuests.length - 3].totalRepeatingClients

  const diff = thisYearsRepeatGuestsNumber - lastYearsRepeatGuestsNumber

  const pieData = [...oneTimeGuests[oneTimeGuests.length - 2].data].reverse()

  return (
    <PieCard
      title="Repeat guests"
      subtitle={`for ${new Date().getFullYear() - 1}`}
      secondaryLabel={`of ${thisYearsTotalGuestNumber} guests`}
      data={pieData}
    >
      <div className={styles.pieBottom}>
        {diff > 0 ? <IncreaseIcon /> : <DecreaseIcon />} {Math.abs(diff)}{' '}
        {diff > 0 ? 'more' : 'less'} guests than last year
      </div>
    </PieCard>
  )
}

const RepeatGuests = () => {
  const oneTimeGuests = useSelector(s => s.insights.oneTimeGuests)
  const repeatGuests = useSelector(s => s.insights.repeatGuests.last2yearsMonthly)

  if (
    oneTimeGuests &&
    repeatGuests &&
    Object.keys(oneTimeGuests).length &&
    Object.keys(repeatGuests).length
  ) {
    return (
      <div className={styles.repeatGuestContainer}>
        <RepeatGuestsPie oneTimeGuests={oneTimeGuests} />
        {repeatGuests && (
          <div style={{ flex: 1, marginLeft: 20 }}>
            <MultiBarCard
              yLabel="guests"
              xLabel="stays"
              data={Object.values(repeatGuests).sort(repeatGuestSorter)}
              title={`Repeat guests breakdown`}
              subtitle={`for ${new Date().getFullYear() - 1}`}
              barSize={18}
              hasLegends
              unit="stays"
            />
          </div>
        )}
      </div>
    )
  }

  return null
}

export default RepeatGuests
